import React, { Component } from 'react';
import './GroupTrends.sass';
import 'react-table/react-table.css';
import Button from '../../../components/common/Button';
import { I18n, i18nReducer } from 'react-redux-i18n';
import Dropdown from '../../../components/common/Dropdown';
import ReactTable from 'react-table';
import Loader from '../../../components/common/Loader';
import ProgressBar from '../../../components/common/ProgressBar/ProgressBar';
import TableLoader from '../../../components/common/TableLoader/TableLoader';
import { GeneratePdfHtml } from './GeneratePdfHtml/GeneratePdfHtml';
import { Tabs, Tab, Thumbnail } from 'react-bootstrap';
import ToolboxColumn from '../../../components/common/ToolboxColumn/ToolboxColumn';
import dayjs from 'dayjs';
import { result } from 'lodash';
import NewIndicator from '../../../components/common/NewIndicator/NewIndicator';
import ExportExcelModal from '../../../components/common/ExportExcelModal/ExportExcelModal';
import MainModal from '../../../components/common/MainModal';
import Tooltip from '../../../components/common/Tooltip';
import LargeTextTooltip from '../../../components/common/LargeTextTooltip';
import { isINESAccount, isINESBranch } from '../../../utils/inesValidator';
import DISCResultsPanel from './DISCResultsPanel';
import {
  clearPersistedGroupTrendsSelection,
  hydratePersistedPersonSelection,
  mapResultsPersonToToolboxItem,
  mergeSelectedPersonsIntoItems,
  remapSelectionOntoLoadedPersons,
  resolveHandoffSelection,
  shouldPreservePersistedSelection,
} from './groupTrendsSelection';
// const html2PDF = require('jspdf-html2canvas');

export {
  hydratePersistedPersonSelection,
  shouldPreservePersistedSelection,
} from './groupTrendsSelection';

const TAB_COMPETENCIES = 'Competencies';
const TAB_JOBS = 'Jobs';
const TAB_DISC = 'DISC';

// nwm_role ids: position_compatibility (17) / disc_report_compatibility (18)
const ROLE_POSITION_COMPATIBILITY = 17;
const ROLE_DISC_COMPATIBILITY = 18;

class GroupTrends extends Component {
  constructor(props) {
    super(props);

    this.state = {
      screen: 'capabilities',
      changeTab: false,
      values: {
        capabilities: { inputValue: [] },
        jobs: { inputValue: [] },
      },
      fetch: false,
      generatePdf: false, // state boolean that triggers GeneratePdfHtml component render
      sorted: {
        id: -1,
        desc: false,
      },
      selectedTab: TAB_COMPETENCIES,
      discCompatibilityMode: 'Competencies',
      selectedPersons: [],
      selectedJobs: [],
      selectedSkills: [],
      exportExcelModalShow: false,
      sorteditem: 0,
      order: 'desc',
      orderDesc: true,
      scroll: false,
      compatibilities: false,
      selectedPersonIds: new Set(), // Global tracking of selected person IDs across pages
      isSelectingAll: false, // Loading state for "select all" operation
      showMaxJobWarning: false,
      showMaxCompetencyWarning: false,
      showMaxPersonWarning: false,
    };
    this.orderCompatibilitiesAscDesc =
      this.orderCompatibilitiesAscDesc.bind(this);
  }

  showDiscWarning = (warningKey) => {
    if (this[`_${warningKey}Timer`]) clearTimeout(this[`_${warningKey}Timer`]);
    this.setState({ [warningKey]: true });
    this[`_${warningKey}Timer`] = setTimeout(() => {
      this.setState({ [warningKey]: false });
    }, 5000);
  };

  isJobsMode = () => {
    return (
      this.state.selectedTab === TAB_JOBS ||
      (this.state.selectedTab === TAB_DISC &&
        this.state.discCompatibilityMode === 'Jobs')
    );
  };

  isJobsTabVisible = () => {
    if (
      isINESBranch(this.props?.user?.branch?.name) ||
      isINESAccount(this.props?.user?.account)
    ) {
      return false;
    }
    return Boolean(
      this.props.user?.user_admin ||
        this.props.user?.groups?.includes(ROLE_POSITION_COMPATIBILITY),
    );
  };

  isDiscTabVisible = () => {
    return Boolean(
      this.props.user?.user_admin ||
        this.props.user?.groups?.includes(ROLE_DISC_COMPATIBILITY),
    );
  };

  componentDidMount() {
    // fall back if the selected tab is hidden for this user
    if (
      (this.state.selectedTab === TAB_JOBS && !this.isJobsTabVisible()) ||
      (this.state.selectedTab === TAB_DISC && !this.isDiscTabVisible())
    ) {
      this.setState({ selectedTab: TAB_COMPETENCIES });
    }
    this.props.cleanToolboxFilter();
    this.props.filterPersons({
      start_range: dayjs().subtract(5, 'years').format('YYYY-MM-DDT00:00:00Z'),
      end_range: dayjs().format('YYYY-MM-DDT00:00:00Z'),
      page_size: 1000,
      statusCompleted: true,
    });
    this.props.updateJobsSearchFilter();
    this.props.getJobs(true);
    this.props.getAllProfiles({});

    this.props.getAllCampaigns({
      //partner_id: this.props.user.branch.id,
      campaign_dropdown: true,
    });

    if (this.props.user.user_admin) {
      this.props.getAllClients(true, false, true);
      this.props.getBranchs(null);
    }
    if (this.props.user.account?.id) {
      this.props.getAllClients(true, false, true);
      this.props.getBranchs({
        account_id: this.props.user.account.id,
      });
    }

    this.props.getProfileSkills();
    const urlSearchParams = new URLSearchParams(
      this.props.history.location.search,
    );
    if (!urlSearchParams.has('selected-items')) {
      clearPersistedGroupTrendsSelection();
      this.props.clearSelection();
    } else {
      const handoffSelection = resolveHandoffSelection(this.props.selection);
      this.setState(
        hydratePersistedPersonSelection(
          handoffSelection,
          this.props.language,
        ),
      );
      if (handoffSelection.length && this.props.restoreSelection) {
        this.props.restoreSelection(handoffSelection);
      }
    }
  }

  componentDidUpdate(prevProps) {
    // NW-2574: page-change refetching is owned exclusively by the UPDATE_PAGE middleware,
    // which dispatches filterPersons({ isPageUpdate: true }) carrying seq + requestedPage.
    // The previous self-refetch here fired a SECOND, untagged filterPersons on every
    // currentPage change. Because it omitted isPageUpdate it floated `current`, which kept
    // reopening the !loading guard between interleaved responses and produced a feedback
    // loop / request cascade (one page click -> many page fetches). Filter changes are
    // handled by handleBackendFilter / dropDownClean; initial load by componentDidMount.
    // This refetch was redundant and is removed.

    // Restore selections from global Set when persons data changes (page change or filter)
    if (
      prevProps.persons !== this.props.persons &&
      this.props.persons &&
      this.state.selectedPersonIds.size > 0
    ) {
      const remapped = remapSelectionOntoLoadedPersons(
        this.props.persons,
        this.state.selectedPersons,
        this.props.language,
      );
      const selectionChanged =
        JSON.stringify(remapped.selectedPersons.map((p) => p.id).sort()) !==
        JSON.stringify(this.state.selectedPersons.map((p) => p.id).sort());
      const idsChanged =
        remapped.selectedPersonIds.size !== this.state.selectedPersonIds.size ||
        [...remapped.selectedPersonIds].some(
          (id) => !this.state.selectedPersonIds.has(id),
        );
      if (selectionChanged || idsChanged) {
        this.setState(remapped);
      }
    }

    if (this.state.fetch) {
      this.props.selectSkill();
      if (this.state.selectedTab === TAB_DISC) {
        if (this.state.selectedPersons.length > 0) {
          const skillIds =
            this.state.selectedSkills && this.state.selectedSkills.length > 0
              ? this.state.selectedSkills.map((s) => s.id)
              : undefined;
          this.props.getDiscProfiles(skillIds);
        }
      } else if (this.isJobsMode()) {
        this.props.getJobCompatibility(
          this.state.selectedJobs.map((job) => job.id),
        );
      } else {
        this.props.getProfileSkillsRanges(
          this.state.selectedSkills.map((skill) => skill.id),
          false,
        );
      }
      this.setState({ ...this.state, fetch: false });
    }

    if (this.state.generatePdf) {
      setTimeout(() => {
        const element = document.getElementById('generatePdf-elementToPrint');
        const fileName =
          I18n.t('persons.emailReport.file.report') +
          (this.state.screen === 'capabilities'
            ? I18n.t('persons.emailReport.file.competencies')
            : I18n.t('persons.emailReport.file.jobs')) +
          '.pdf';
        // html2pdf(element, {
        //     filename: I18n.t('persons.emailReport.file.report') + ((this.state.screen === 'capabilities') ?
        //         I18n.t('persons.emailReport.file.competencies')
        //         :
        //         I18n.t('persons.emailReport.file.jobs')) + '.pdf',
        //     image: { type: 'jpeg', quality: 0.98 },
        //     html2canvas: { scale: 2 },
        //     jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
        // });
        // html2PDF(element, {
        //   jsPDF: {
        //     format: 'a4',
        //   },
        //   imageType: 'image/png',
        //   output: fileName,
        // });
        this.setState({ ...this.state, generatePdf: false });
      }, 500);
    }
  }

  componentWillUnmount() {
    if (this.fetchTiemout) {
      clearTimeout(this.fetchTiemout);
    }
    if (this._showMaxJobWarningTimer) clearTimeout(this._showMaxJobWarningTimer);
    if (this._showMaxCompetencyWarningTimer) clearTimeout(this._showMaxCompetencyWarningTimer);
    if (this._showMaxPersonWarningTimer) clearTimeout(this._showMaxPersonWarningTimer);
    if (this._paginationKeyInterval) {
      clearInterval(this._paginationKeyInterval);
      this._paginationKeyInterval = null;
    }

    // Clear the persisted toolbox filter so ToolboxColumn doesn't rehydrate
    // stale values when the user re-enters the flow (NW-2594)
    this.props.cleanToolboxFilter();

    if (!shouldPreservePersistedSelection(this.props.history?.location)) {
      clearPersistedGroupTrendsSelection();
      this.props.clearSelection();
    }
  }

  addOption = (type, name, option) => {
    if (type === 'add' && this.state.values[name].inputValue.length >= 4)
      return;
    let newArray;
    if (type === 'add')
      newArray = [
        ...[{ ...option }].concat(this.state.values[name].inputValue),
      ];
    else if (type === 'remove')
      newArray = [
        ...this.state.values[name].inputValue.filter(
          (selectedOption) => selectedOption.code !== option.code,
        ),
      ];
    else newArray = [...this.state.values[name].inputValue];

    newArray.sort((elem1, elem2) => {
      return elem1.code - elem2.code;
    });

    this.setState({
      ...this.state,
      values: {
        ...this.state.values,
        [name]: { ...this.state.values[name], inputValue: newArray },
      },
    });

    if (this.fetchTiemout) clearTimeout(this.fetchTiemout);
    this.fetchTiemout = setTimeout(
      function () {
        this.setState({ ...this.state, fetch: true });
      }.bind(this),
      500,
    );
  };
  processData = (data, limitatedColumns) => {
    const { screen, sorted } = this.state;
    const defaultSorted = sorted;
    const sortedData = data.sort((valueA, valueB) => {
      const getValue = (item) => {
        const sortedId = defaultSorted.id === -1 ? 0 : defaultSorted.id;
        if (screen === 'capabilities') {
          if (typeof defaultSorted.id === 'string') {
            if (defaultSorted.id === 'name')
              return item.first_name + ' ' + item.last_name;
            if (defaultSorted.id === 'profile') return item.result_profile;
            return item.first_name + ' ' + item.last_name;
          }
          if (item.skills_range[sortedId] === undefined) return null;
          else return item.skills_range[sortedId].min;
        } else {
          if (typeof defaultSorted.id === 'string') {
            if (defaultSorted.id === 'name')
              return item.first_name + ' ' + item.last_name;
            if (defaultSorted.id === 'profile') {
              const match = item.profile_match.filter(
                (match) => match.profile_one.id === item.profile_id,
              )[0];
              return match ? match.profile_one.name : null;
            }
            return item.first_name + ' ' + item.last_name;
          }
          const columnSelected =
            defaultSorted.id === -1
              ? limitatedColumns[0]
              : limitatedColumns.find((col) => col.code === defaultSorted.id);
          const match = item.profile_match.filter(
            (match) =>
              match &&
              columnSelected &&
              match.profile_one.id === item.profile_id &&
              match.profile_two.id === columnSelected.profile,
          )[0];
          if (!match) return null;
          return match.value;
        }
      };
      const a = getValue(valueA);
      const b = getValue(valueB);
      if (typeof defaultSorted.id === 'string') {
        if (defaultSorted.desc) {
          if (a !== null && b !== null) return b.localeCompare(a);
          else if (a !== null) return 1;
          else return -1;
        } else {
          if (a !== null && b !== null) return a.localeCompare(b);
          else if (a !== null) return -1;
          else return 1;
        }
      } else {
        if (defaultSorted.desc) {
          if (a !== null && b !== null) return a - b;
          else if (a !== null) return 1;
          else return -1;
        } else {
          if (a !== null && b !== null) return b - a;
          else if (a !== null) return -1;
          else return 1;
        }
      }
    });
    return sortedData;
  };

  handleGenerateExcel = async (name, option) => {
    // const { screen } = this.state;
    // const all =
    //   this.state.screen === 'capabilities'
    //     ? this.props.profileSkills.map((skill) => ({
    //         code: skill.id,
    //         description: skill.name,
    //       }))
    //     : this.props.jobs.map((job) => ({
    //         code: job.id,
    //         description: job[`name_${this.props.language}`],
    //         profile: job.profile.id,
    //       }));
    // const selected = this.state.values[this.state.screen].inputValue;
    // const values = option.code === 'all' ? all : selected;
    // let columns = [
    //   { description: I18n.t('persons.first_name') },
    //   { description: I18n.t('persons.profile') },
    //   ...values,
    // ];
    // const tableData =
    //   columns.length > 0
    //     ? this.state.screen === 'capabilities'
    //       ? option.code === 'all'
    //         ? this.props.allProfileSkillsRanges
    //         : this.props.profileSkillsRanges
    //       : option.code === 'all'
    //       ? this.props.allJobCompatibility
    //       : this.props.jobCompatibility
    //     : [];
    // const processData = this.processData(tableData, values);
    ////////////////////////////////////////////////////////////////
    // let ids = [];
    // let capabilities = false;
    // if (this.state.screen === 'capabilities') {
    //   if (option.code === 'all') {
    //     ids = this.props.profileSkills.map((i) => i.id);
    //   } else {
    //     ids = this.state.values.capabilities.inputValue.map(
    //       (skill) => skill.code,
    //     );
    //   }
    //   capabilities = true;
    // } else {
    //   if (option.code === 'all') {
    //     ids = this.props.jobs.map((i) => i.id);
    //   } else {
    //     ids = this.state.values.jobs.inputValue.map((job) => job.code);
    //   }
    // }
    let ids = [];
    let capabilities = !this.isJobsMode();
    if (name === 'selected') {
      if (
        this.state[
          `selected${this.isJobsMode() ? 'Jobs' : 'Skills'}`
        ].length > 0
      ) {
        ids = this.state[
          `selected${this.isJobsMode() ? 'Jobs' : 'Skills'}`
        ].map((i) => i.id);
      }
    }
    if (name === 'all') {
      ids = this.props[
        `${this.isJobsMode() ? 'jobs' : 'profileSkills'}`
      ].map((i) => i.id);
    }
    this.props.exportTrend(ids, capabilities);
  };
  handleBackendFilter = async (filter) => {
    let branchList = filter?.branchs?.code;

    if (
      filter?.partner_ids &&
      (!filter?.branchs || filter?.branchs?.code === -1)
    ) {
      let branchs_x_partner = this.props.branchs.filter(
        (b) => b.nwm_accountId === filter.partner_ids.code,
      );
      branchList = branchs_x_partner.map((branch) => branch.id);
    }

    if (this.props.user.user_admin) {
      let partner_id_ = null;

      if (!filter?.partner_ids) {
        this.props.getBranchs(null);
      } else {
        partner_id_ = filter.partner_ids.code;
        this.props.getBranchs({
          account_id: filter?.partner_ids.code,
        });
      }
      this.props.getAllCampaigns({
        queryPartners: branchList,
        campaign_dropdown: true,
        partner_id: partner_id_,
      });
    }
    if (this.props.user.account?.id) {
      if (!filter?.branchs || filter?.branchs?.code === -1) {
        let branchs_x_partner = this.props.branchs.filter(
          (b) => b.nwm_accountId === this.props.user.account?.id,
        );
        branchList = branchs_x_partner.map((branch) => branch.id);
      }
      this.props.getBranchs({
        account_id: this.props.user.account.id,
      });

      this.props.getAllCampaigns({
        queryPartners: branchList,
        campaign_dropdown: true,
        partner_id: this.props.user.account?.id,
      });
    }

    await this.props.filterPersons({
      start_range: dayjs().subtract(5, 'years').format('YYYY-MM-DDT00:00:00Z'),
      end_range: dayjs().format('YYYY-MM-DDT00:00:00Z'),
      campaigns: filter?.caption?.code,
      profiles: filter?.subtitle?.code,
      partner_ids: filter?.partner_ids?.code,
      branchs: branchList,
      search: filter?.title,
      page_size: filter?.page_size || 1000,
      statusCompleted: true,
    });
  };
  handleSelect = async (key, value, items) => {
    //defino una variable para chequear si esta o no seleccionado
    let valuesToRemove;
    let itemExist;
    let allItems;
    if (key === 'selectedPersons') {
      allItems = 'persons';
    }
    if (key === 'selectedJobs') allItems = 'jobs';
    // chequeo si existe en el estado
    itemExist = this.state[key]?.find((item) => {
      return item.id_results
        ? item?.id_results === value?.id_results
        : item.id === value.id;
    });
    // si no esta: la agrego si esta: lo saco
    if (value === 'remove-all') {
      if (key === 'selectedPersons') {
        clearPersistedGroupTrendsSelection();
      }
      if (this.state[key][0].id_results) {
        valuesToRemove = this.state[key];
      }
      this.setState(
        {
          ...this.state,
          [key]: [],
          selectedPersonIds:
            key === 'selectedPersons'
              ? new Set()
              : this.state.selectedPersonIds,
        },
        () => {
          if (valuesToRemove && valuesToRemove[0]?.id_results) {
            valuesToRemove?.map((val) => {
              this.props.addRemovePersonToSelection({
                id_result: val.id_results,
                id_invitation: val.id_invitation,
              });
            });
          }
        },
      );
    }
    if (value === 'add-all') {
      // Bloquear add-all para personas en tab DISC (max 5, no tiene sentido)
      if (key === 'selectedPersons' && this.state.selectedTab === TAB_DISC) {
        return;
      }
      // Verificar límite de 5000 antes de seleccionar todos
      if (key === 'selectedPersons') {
        const currentSelectionCount = this.state.selectedPersonIds.size;
        const availableSlots = 5000 - currentSelectionCount;

        if (currentSelectionCount >= 5000) {
          alert(
            I18n.t('toolbox.maxSelectionReached') ||
              'Has alcanzado el límite máximo de 5000 selecciones.',
          );
          return;
        }

        if (items.length > availableSlots) {
          const willExceed =
            currentSelectionCount +
            items.filter((item) => !this.state.selectedPersonIds.has(item.id))
              .length;
          if (willExceed > 5000) {
            alert(
              `Solo puedes seleccionar ${availableSlots} elementos más para no exceder el límite de 5000.`,
            );
            return;
          }
        }
      }

      // Mostrar loader antes de iniciar la operación
      this.setState({ isSelectingAll: true });

      // Usar setTimeout para permitir que el loader se renderice
      setTimeout(() => {
        const newSelectedIds = new Set(this.state.selectedPersonIds);
        let mergedItems = [...this.state[key]];

        if (key === 'selectedPersons') {
          // Agregar solo los items que no están ya seleccionados y no exceden el límite
          let addedCount = 0;
          items.forEach((item) => {
            if (!newSelectedIds.has(item.id) && newSelectedIds.size < 5000) {
              newSelectedIds.add(item.id);
              mergedItems.push(item);
              addedCount++;
            }
          });
        } else {
          mergedItems = items;
        }

        this.setState(
          {
            ...this.state,
            [key]: mergedItems,
            fetch: true,
            selectedPersonIds:
              key === 'selectedPersons'
                ? newSelectedIds
                : this.state.selectedPersonIds,
            isSelectingAll: false, // Ocultar loader después de completar
          },
          () => {
            if (key === 'selectedPersons') {
              //borro los actualmente seleccionados para agregar a todos luego
              this.props.selection.map((itemToRemove) => {
                this.props.addRemovePersonToSelection({
                  id_result: itemToRemove.id_results,
                  id_invitation: itemToRemove.id_invitation,
                });
              });
              this.state[key].map((item) => {
                this.props.addRemovePersonToSelection({
                  id_result: item.id_results,
                  id_invitation: item.id_invitation,
                });
              });
            }

            this.setState({
              ...this.state,
              fetch: true,
            });
          },
        );
      }, 100);
    }
    if (itemExist === undefined && typeof value !== 'string') {
      // Verificar límite DISC de 5 personas
      if (
        key === 'selectedPersons' &&
        this.state.selectedTab === TAB_DISC &&
        this.state.selectedPersons.length >= 5
      ) {
        return;
      }
      // Disparar warnings al alcanzar el máximo en DISC
      if (this.state.selectedTab === TAB_DISC) {
        if (key === 'selectedPersons' && this.state.selectedPersons.length + 1 >= 5) {
          this.showDiscWarning('showMaxPersonWarning');
        }
        if (key === 'selectedJobs' && this.state.selectedJobs.length + 1 >= 1) {
          this.showDiscWarning('showMaxJobWarning');
        }
        if (key === 'selectedSkills' && this.state.selectedSkills.length + 1 >= 5) {
          this.showDiscWarning('showMaxCompetencyWarning');
        }
      }
      // Verificar límite de 5000 antes de agregar
      if (
        key === 'selectedPersons' &&
        this.state.selectedPersonIds.size >= 5000
      ) {
        alert(
          I18n.t('toolbox.maxSelectionReached') ||
            'Has alcanzado el límite máximo de 5000 selecciones.',
        );
        return;
      }

      if (value.id_results) {
        this.props.addRemovePersonToSelection({
          id_result: value.id_results,
          id_invitation: value.id_invitation,
        });
      }
      const newSelectedIds = new Set(this.state.selectedPersonIds);
      if (key === 'selectedPersons') {
        newSelectedIds.add(value.id);
      }
      this.setState(
        {
          ...this.state,
          [key]: [...this.state[key], value],
          fetch: value.id_result ? false : true,
          selectedPersonIds:
            key === 'selectedPersons'
              ? newSelectedIds
              : this.state.selectedPersonIds,
        },
        // () => {
        //   if (value.id_results) {
        //     this.props.addRemovePersonToSelection({
        //       id_result: value.id_results,
        //       id_invitation: value.id_invitation,
        //     });

        //     this.setState({ ...this.state, fetch: true }, () => {});
        //   }
        // },
      );
    }
    if (itemExist !== undefined && typeof value !== 'string') {
      if (value.id_results) {
        this.props.addRemovePersonToSelection({
          id_result: itemExist.id_results,
          id_invitation: itemExist.id_invitation,
        });
      }
      const newSelectedIds = new Set(this.state.selectedPersonIds);
      if (key === 'selectedPersons') {
        newSelectedIds.delete(value.id);
      }
      this.setState(
        {
          ...this.state,
          fetch: true,
          [key]: this.state[key].filter((item) =>
            item.id_results
              ? item.id_results !== value.id_results
              : item.id !== value.id,
          ),
          selectedPersonIds:
            key === 'selectedPersons'
              ? newSelectedIds
              : this.state.selectedPersonIds,
        },
        // () => {
        //   this.setState({
        //     ...this.state,
        //     fetch: true,
        //   });
        // },
      );
    }
  };
  modalShow = () => {
    if (this.state.exportExcelModalShow === false) {
      this.setState({
        ...this.state,
        exportExcelModalShow: true,
      });
    } else {
      this.setState({
        ...this.state,
        exportExcelModalShow: false,
      });
    }
  };
  sortCompatibilities = (id) => {
    this.setState({
      ...this.state,
      sorteditem: id,
      orderDesc: !this.state.orderDesc,
    });
  };
  updatePageSize = async (pageSize) => {
    return await this.props.updatePageSize(pageSize);
  };
  tooltipMessage = (selectedTab) => {
    return (
      <>
        {I18n.t(`toolbox.tooltip${selectedTab}`)}
        {selectedTab === 'Competencies' && (
          <>
            <b className="font-bold">{I18n.t('toolbox.boldedWords')}</b>{' '}
            {I18n.t('toolbox.tooltipCompetenciesNextPart')}
          </>
        )}
      </>
    );
  };
  orderCompatibilitiesAscDesc = (items, orderDesc) => {
    if (orderDesc) {
      return items.sort(
        (a, b) =>
          b.values?.find(
            (v) =>
              v[
                `${
                  this.isJobsMode() ? 'position_id' : 'skill_id'
                }`
              ] == this.state.sorteditem,
          )?.value -
          a.values?.find(
            (v) =>
              v[
                `${
                  this.isJobsMode() ? 'position_id' : 'skill_id'
                }`
              ] == this.state.sorteditem,
          )?.value,
      );
    } else {
      return items.sort(
        (a, b) =>
          a.values?.find(
            (v) =>
              v[
                `${
                  this.isJobsMode() ? 'position_id' : 'skill_id'
                }`
              ] == this.state.sorteditem,
          )?.value -
          b.values?.find(
            (v) =>
              v[
                `${
                  this.isJobsMode() ? 'position_id' : 'skill_id'
                }`
              ] == this.state.sorteditem,
          )?.value,
      );
    }
  };

  dropDownClean = () => {
    this.props.cleanToolboxFilter();
    this.props.filterPersons({
      start_range: dayjs().subtract(5, 'years').format('YYYY-MM-DDT00:00:00Z'),
      end_range: dayjs().format('YYYY-MM-DDT00:00:00Z'),
      page_size: 1000,
      statusCompleted: true,
    });
    this.props.getJobs(true);
    this.props.getAllProfiles({});
    this.props.getAllCampaigns({
      partners: null,
      campaign_dropdown: true,
    });

    if (this.props.user.user_admin) {
      this.props.getAllClients(true, false, true);
      this.props.getBranchs(null);
    }
    if (this.props.user.account?.id) {
      this.props.getAllClients(true, false, true);
      this.props.getBranchs({
        account_id: this.props.user.account.id,
      });
    }
  };

  render() {
    const { screen, selectedTab } = this.state;
    const { capabilities, jobs } = this.state.values;

    // Determinar el loading correcto según la pestaña activa
    const loading = this.isJobsMode()
      ? this.props.jobsCompatibilityStatus?.loading
      : this.props.getProfileSkillsRangesStatus?.loading;

    let compatibilities = false;
    if (this.state.selectedPersons.length) {
      if (this.isJobsMode() && this.state.selectedJobs.length) {
        compatibilities = this.state.selectedJobs;
      }
      if (this.state.selectedTab === 'Competencies' && this.state.selectedSkills.length) {
        compatibilities = this.state.selectedSkills;
      }
      if (this.state.selectedTab === TAB_DISC) {
        if (this.state.discCompatibilityMode === 'Jobs' && this.state.selectedJobs.length) {
          compatibilities = this.state.selectedJobs;
        } else if (this.state.selectedSkills.length) {
          compatibilities = this.state.selectedSkills;
        }
      }
    }
    return (
      <>
        {this.state.exportExcelModalShow && (
          <ExportExcelModal
            show={this.state.exportExcelModalShow}
            action={this.handleGenerateExcel}
            onHide={this.modalShow}
            selectedTab={this.state.selectedTab}
            jobOrSkillSelected={
              this.isJobsMode()
                ? this.state.selectedJobs.length > 0
                  ? true
                  : false
                : this.state.selectedSkills.length > 0
                ? true
                : false
            }
          />
        )}

        <Tabs
          activeKey={this.state.selectedTab}
          id="uncontrolled-tab-example"
          className="compatibilities-and-jobs-container"
          onSelect={(option) => {
            if (option === TAB_DISC) {
              const trimmedPersons = this.state.selectedPersons.slice(0, 5);
              const removedPersons = this.state.selectedPersons.slice(5);
              removedPersons.forEach((person) => {
                if (person.id_results) {
                  this.props.addRemovePersonToSelection({
                    id_result: person.id_results,
                    id_invitation: person.id_invitation,
                  });
                }
              });
              this.setState({
                ...this.state,
                selectedTab: option,
                selectedPersons: trimmedPersons,
                selectedJobs: this.state.selectedJobs.slice(0, 1),
                selectedSkills: this.state.selectedSkills.slice(0, 5),
                selectedPersonIds: new Set(trimmedPersons.map((p) => p.id)),
                fetch: true,
              });
              return;
            }
            this.setState({
              ...this.state,
              selectedTab: option,
              fetch: true,
            });
          }}
        >
          <div key={this.state.changeTab}>
            {this.renderHeader(this.state.changeTab)}
          </div>
          <Tab
            eventKey={TAB_COMPETENCIES}
            title={I18n.t('toolbox.competencies')}
            className="tab-variables-container"
          >
            {this.state.selectedTab === TAB_COMPETENCIES && (
              <>
                {this.renderPersons()}
                {this.renderSkills()}
                {this.renderResults(compatibilities, loading)}
              </>
            )}
          </Tab>
          {this.isJobsTabVisible() ? (
            <Tab
              eventKey={TAB_JOBS}
              title={I18n.t('toolbox.jobs')}
              className="tab-variables-container"
            >
              {this.state.selectedTab === TAB_JOBS && (
                <>
                  {this.renderPersons()}
                  {this.renderPositions()}
                  {this.renderResults(compatibilities, loading)}
                </>
              )}
            </Tab>
          ) : null}
          {this.isDiscTabVisible() ? (
            <Tab
              eventKey={TAB_DISC}
              title={I18n.t('toolbox.discReports')}
              className="tab-variables-container"
            >
              {this.state.selectedTab === TAB_DISC && (
                <>
                  {this.renderDiscPersons()}
                  {this.renderCompatibility()}
                  {this.renderResults(compatibilities, loading)}
                </>
              )}
            </Tab>
          ) : null}
        </Tabs>
      </>
    );
  }

  renderProfileSkillsDropdown() {
    const { loading, error } = this.props.getProfileSkillsRangesStatus;
    if (loading) return <Loader />;
    if (error)
      return (
        <div className="text-warning">
          {I18n.t('persons.groupTrends.error.getJobs')}
        </div>
      );
    return (
      <Dropdown
        multiSelect
        name="jobs"
        key={'jobs'}
        value={this.state.values.jobs}
        addOption={this.addOption}
        placeholder={I18n.t('persons.selectJobs')}
        options={this.props.jobs.map((job) => ({
          code: job.id,
          description: job.name,
          profile: job.profile.id,
        }))}
      />
    );
  }

  renderJobCompatibilityDropdown() {
    const { loading, error } = this.props.jobsStatus;
    if (loading) return <Loader />;
    if (error)
      return (
        <div className="text-warning">
          {I18n.t('persons.groupTrends.error.getJobs')}
        </div>
      );
    return (
      <Dropdown
        multiSelect
        value={this.state.values.capabilities}
        addOption={this.addOption}
        name="capabilities"
        key={'capabilities'}
        placeholder={I18n.t('persons.selectProfiles')}
        options={this.props.profileSkills.map((skill) => ({
          code: skill.id,
          description: skill[`name_${this.props.language}`],
        }))}
      />
    );
  }

  getToolboxPersonItems = () => {
    const pageItems = (this.props.persons || []).map((person) =>
      mapResultsPersonToToolboxItem(person, this.props.language),
    );
    // Wait for the list fetch. Merging the handoff snapshot while
    // persons is still [] makes the toolbox show only the selected
    // person, then jump to the full list when the request resolves.
    if (
      this.props.retrieveFilter?.loading ||
      !this.props.retrieveFilter?.success
    ) {
      return pageItems;
    }
    return mergeSelectedPersonsIntoItems(
      pageItems,
      this.state.selectedPersons,
    );
  };

  renderPersons = () => {
    if (this.props.persons) {
      return (
        <ToolboxColumn
          className="persons"
          title={
            <span className="column-title">{I18n.t('persons.identifier')}</span>
          }
          customFilter={this.props.customFilter}
          selected={this.state.selectedPersons}
          selectedIds={this.state.selectedPersonIds}
          handleSelect={this.handleSelect}
          getAllClients={({ account_dropdown, view_branch, view_account }) => {
            this.props.getAllClients(
              account_dropdown,
              view_branch,
              view_account,
            );
          }}
          getBranchs={this.props.getBranchs}
          allClients={this.props.allClients}
          branchs={this.props.branchs}
          totalCount={this.props.totalCount}
          loading={this.props.retrieveFilter.loading || false}
          items={this.getToolboxPersonItems()}
          campaigns={this.props.allCampaigns.map((campaign) => ({
            caption: {
              code: campaign.id,
              description: campaign.name,
            },
          }))}
          profiles={this.props.allProfiles.map((profile) => {
            if (profile.id !== 27) {
              return {
                subtitle: {
                  code: profile.id,
                  description: profile.name,
                },
              };
            }
          })}
          name={'selectedPersons'}
          fetch={this.handleBackendFilter}
          backendFetch
          updateToolboxFilter={this.props.updateToolboxFilter}
          toolboxFilter={this.props.toolboxFilterPersons}
          isAdmin={this.props.user?.user_admin ? true : false}
          isUserAccount={this.props.user?.account?.id ? true : false}
          dropDownClean={this.dropDownClean}
          showPagination={true}
          currentPage={this.props.currentPage}
          totalPages={this.props.totalPages}
          pageSize={this.props.pageSize}
          updatePage={this.props.updatePage}
          isSelectingAll={this.state.isSelectingAll}
        />
      );
    } else {
      return <Loader />;
    }
  };

  renderDiscPersons = () => {
    if (this.props.persons) {
      const personSubHeader = this.state.showMaxPersonWarning ? (
        <div className="disc-max-warning">
          {I18n.t('toolbox.maxPersonWarning')}
        </div>
      ) : null;
      return (
        <ToolboxColumn
          className="persons"
          subHeader={personSubHeader}
          title={
            <span className="column-title">{I18n.t('persons.identifier')}</span>
          }
          customFilter={this.props.customFilter}
          selected={this.state.selectedPersons}
          selectedIds={this.state.selectedPersonIds}
          handleSelect={this.handleSelect}
          getAllClients={({ account_dropdown, view_branch, view_account }) => {
            this.props.getAllClients(
              account_dropdown,
              view_branch,
              view_account,
            );
          }}
          getBranchs={this.props.getBranchs}
          allClients={this.props.allClients}
          branchs={this.props.branchs}
          totalCount={this.props.totalCount}
          loading={this.props.retrieveFilter.loading || false}
          items={this.getToolboxPersonItems()}
          campaigns={this.props.allCampaigns.map((campaign) => ({
            caption: {
              code: campaign.id,
              description: campaign.name,
            },
          }))}
          profiles={this.props.allProfiles.map((profile) => {
            if (profile.id !== 27) {
              return {
                subtitle: {
                  code: profile.id,
                  description: profile.name,
                },
              };
            }
          })}
          name={'selectedPersons'}
          fetch={this.handleBackendFilter}
          backendFetch
          updateToolboxFilter={this.props.updateToolboxFilter}
          toolboxFilter={this.props.toolboxFilterPersons}
          isAdmin={this.props.user?.user_admin ? true : false}
          isUserAccount={this.props.user?.account?.id ? true : false}
          dropDownClean={this.dropDownClean}
          showPagination={true}
          currentPage={this.props.currentPage}
          totalPages={this.props.totalPages}
          pageSize={this.props.pageSize}
          updatePage={this.props.updatePage}
          isSelectingAll={this.state.isSelectingAll}
          maxSelection={5}
        />
      );
    } else {
      return <Loader />;
    }
  };

  renderSkills = () => {
    return (
      <ToolboxColumn
        className="skills"
        infiniteScroll={false}
        title={I18n.t('toolbox.competencies')}
        headerIcon={
          <Tooltip
            message={this.tooltipMessage(this.state.selectedTab)}
            translate={false}
            materialIcon="contact_support"
            className={`tooltip-on-${this.state.selectedTab}`}
          />
        }
        items={this.props.profileSkills.map((job) => ({
          id: job.id,
          title: job[`name_${this.props.language}`],
          description: job[`description_${this.props.language}`],
          name_es: job.name_es,
        }))}
        selected={this.state.selectedSkills}
        handleSelect={this.handleSelect}
        name={'selectedSkills'}
        totalCount={this.props.profileSkills?.length || 0}
        updateToolboxFilter={this.props.updateToolboxFilter}
        toolboxFilter={this.props.toolboxFilterSkills}
        profiles={this.props.allProfiles.map((profile) => {
          if (profile.id !== 27) {
            return {
              subtitle: {
                code: profile.id,
                description: profile.name,
              },
            };
          }
        })}
        dropDownClean={this.dropDownClean}
      />
    );
  };

  renderCompatibility = () => {
    const isJobsMode = this.state.discCompatibilityMode === 'Jobs';

    const toggleBtnStyle = {
      minWidth: 'auto',
      padding: '6px 16px',
      margin: 0,
    };

    const crossItems = isJobsMode
      ? this.state.selectedSkills
      : this.state.selectedJobs;
    const crossLabel = isJobsMode
      ? I18n.t('toolbox.selectedCompetencies')
      : I18n.t('toolbox.selectedJobs');
    const crossKey = isJobsMode ? 'selectedSkills' : 'selectedJobs';

    const subHeader = (
      <>
        <div className="disc-compat-toggle">
          <button
            className={`button ${isJobsMode ? 'primary' : 'secondary'}`}
            style={toggleBtnStyle}
            onClick={() =>
              this.setState({ discCompatibilityMode: 'Jobs', fetch: true })
            }
          >
            <span>{I18n.t('toolbox.jobs')}</span>
          </button>
          <button
            className={`button ${!isJobsMode ? 'primary' : 'secondary'}`}
            style={toggleBtnStyle}
            onClick={() =>
              this.setState({
                discCompatibilityMode: 'Competencies',
                fetch: true,
              })
            }
          >
            <span>{I18n.t('toolbox.competencies')}</span>
          </button>
        </div>
        {isJobsMode && this.state.showMaxJobWarning && (
          <div className="disc-max-warning">
            {I18n.t('toolbox.maxJobWarning')}
          </div>
        )}
        {!isJobsMode && this.state.showMaxCompetencyWarning && (
          <div className="disc-max-warning">
            {I18n.t('toolbox.maxCompetencyWarning')}
          </div>
        )}
        {crossItems.length > 0 && (
          <div style={{ marginBottom: '8px' }}>
            <div
              style={{
                fontSize: '12px',
                color: '#888',
                marginBottom: '4px',
              }}
            >
              {crossLabel}
            </div>
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '4px',
                maxHeight: '80px',
                overflowY: 'auto',
              }}
            >
              {crossItems.map((item) => (
                <div
                  key={item.id}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '4px',
                    padding: '2px 8px',
                    backgroundColor: 'rgba(119, 61, 176, 0.1)',
                    border: '1px solid rgba(119, 61, 176, 0.2)',
                    borderRadius: '6px',
                    fontSize: '12px',
                    color: '#773db0',
                    fontWeight: '500',
                  }}
                >
                  <span
                    style={{
                      maxWidth: '150px',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                    title={item.title}
                  >
                    {item.title}
                  </span>
                  <button
                    style={{
                      background: 'none',
                      border: 'none',
                      color: '#773db0',
                      cursor: 'pointer',
                      padding: 0,
                      display: 'flex',
                      alignItems: 'center',
                      fontSize: '14px',
                      lineHeight: 1,
                    }}
                    onClick={() =>
                      this.handleSelect(crossKey, item)
                    }
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </>
    );

    if (isJobsMode) {
      return (
        <ToolboxColumn
          className="positions"
          infiniteScroll={false}
          title={I18n.t('toolbox.compatibility')}
          subHeader={subHeader}
          headerIcon={
            <Tooltip
              message={I18n.t('toolbox.tooltipDiscJobs')}
              translate={false}
              materialIcon="help"
              className="tooltip-on-Jobs"
            />
          }
          items={this.props.jobs.map((job) => ({
            id: job.id,
            title: job.name,
            subtitle: job?.profile[`name_${this.props.language}`],
          }))}
          selected={this.state.selectedJobs}
          handleSelect={this.handleSelect}
          name={'selectedJobs'}
          totalCount={this.props.jobs?.length || 0}
          updateToolboxFilter={this.props.updateToolboxFilter}
          toolboxFilter={this.props.toolboxFilterJobs}
          profiles={this.props.allProfiles.map((profile) => {
            if (profile.id !== 27) {
              return {
                subtitle: {
                  code: profile.id,
                  description: profile.name,
                },
              };
            }
          })}
          dropDownClean={this.dropDownClean}
          maxSelection={1}
        />
      );
    }

    return (
      <ToolboxColumn
        className="skills"
        infiniteScroll={false}
        title={I18n.t('toolbox.compatibility')}
        subHeader={subHeader}
        headerIcon={
          <Tooltip
            message={I18n.t('toolbox.tooltipDISC')}
            translate={false}
            materialIcon="help"
            className={`tooltip-on-${this.state.selectedTab}`}
          />
        }
        items={this.props.profileSkills.map((skill) => ({
          id: skill.id,
          title: skill[`name_${this.props.language}`],
          description: skill[`description_${this.props.language}`],
          name_es: skill.name_es,
        }))}
        selected={this.state.selectedSkills}
        handleSelect={this.handleSelect}
        name={'selectedSkills'}
        totalCount={this.props.profileSkills?.length || 0}
        updateToolboxFilter={this.props.updateToolboxFilter}
        toolboxFilter={this.props.toolboxFilterSkills}
        profiles={this.props.allProfiles.map((profile) => {
          if (profile.id !== 27) {
            return {
              subtitle: {
                code: profile.id,
                description: profile.name,
              },
            };
          }
        })}
        dropDownClean={this.dropDownClean}
        maxSelection={5}
      />
    );
  };

  renderResults = (results, loading) => {
    this.changeKeyToPagination();

    // DISC tab: render DISCResultsPanel when persons are selected
    if (this.state.selectedTab === TAB_DISC) {
      if (this.state.selectedPersons.length > 0) {
        return (
          <div
            className={`results results-${this.state.selectedTab}`}
            id="container"
            key={this.state.selectedTab}
          >
            <DISCResultsPanel
              selectedPersons={this.state.selectedPersons}
              selectedCompetencias={this.state.selectedSkills}
              selectedPuestos={this.state.selectedJobs}
              discProfiles={this.props.discProfiles}
              loading={this.props.getDiscProfilesStatus?.loading}
              discGap={this.props.discGap}
              discGapStatus={this.props.discGapStatus}
              getDiscGap={this.props.getDiscGap}
              groupArts={this.props.groupArts}
              groupArtsStatus={this.props.groupArtsStatus}
              getGroupArts={this.props.getGroupArts}
            />
          </div>
        );
      }
      return (
        <div
          className={`results results-${this.state.selectedTab}`}
          id="container"
          key={this.state.selectedTab}
        >
          <div className="not-selected-view">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
            <p>{I18n.t('toolbox.discNotSelected')}</p>
          </div>
        </div>
      );
    }

    return (
      <div
        className={`results results-${this.state.selectedTab}`}
        id="container"
        key={this.state.selectedTab}
      >
        {loading && (
          <div className="results-loader-container">
            <Loader />
          </div>
        )}
        {!loading && results.length ? (
          results.map((result) => {
            return (
              <div className="result-column">
                <div
                  className={`result-title ${
                    result.id === this.state.sorteditem ? 'active' : ''
                  } `}
                  key={'result-' + result.id}
                >
                  <div
                    onClick={() => this.sortCompatibilities(result.id)}
                    className="first-item"
                  >
                    <div
                      className="text"
                      id={`title-result-${result.id}`}
                      data-tooltip-id={`title-result-tooltip-${result.id}`}
                      data-tooltip-content={result.title}
                    >
                      {result.title}
                    </div>
                    <LargeTextTooltip
                      id={`title-result-tooltip-${result.id}`}
                      idToOverflow={`title-result-${result.id}`}
                    />
                    <div class="material-symbols-rounded">
                      arrow_drop_
                      {this.state.orderDesc ? 'down' : 'up'}
                    </div>
                  </div>
                  <div
                    class="material-symbols-rounded"
                    onClick={() =>
                      this.handleSelect(
                        this.isJobsMode()
                          ? 'selectedJobs'
                          : 'selectedSkills',
                        result,
                      )
                    }
                  >
                    close
                  </div>
                </div>
                <div className="job-body">
                  {this?.orderCompatibilitiesAscDesc(
                    this.props[
                      `${
                        this.isJobsMode()
                          ? 'jobCompatibility'
                          : 'profileSkillsRanges'
                      }`
                    ],
                    this.state.orderDesc,
                  )?.map((results, key) => {
                    return (
                      <div className="person-card">
                        <div className="person-card-first-element">
                          <div>
                            <div className="person-name">
                              {results.full_name}{' '}
                            </div>
                            <div className="person-profile">
                              {results.profile_name}
                            </div>
                          </div>
                          <div
                            class="material-symbols-rounded"
                            onClick={() =>
                              this.handleSelect('selectedPersons', {
                                ...results,
                                id: results.id_invitation,
                                title: results.full_name,
                                subtitle: {
                                  code: key,
                                  description: results.profile_name,
                                },
                              })
                            }
                          >
                            close
                          </div>
                        </div>
                        <ProgressBar
                          value={
                            results?.values?.find(
                              (r) =>
                                r[
                                  `${
                                    this.isJobsMode()
                                      ? 'position_id'
                                      : 'skill_id'
                                  }`
                                ] === result.id,
                            )?.value
                          }
                          long={10}
                          // label={'s'}
                          // name={'s'}
                          compatibilities
                        />
                      </div>
                    );
                  })}
                  {this.props.retrieveFilter &&
                    (this.props.retrieveFilter === 'true' ? <Loader /> : '')}
                </div>
              </div>
            );
          })
        ) : (
          <div className="not-selected-view">
            <div class="material-symbols-rounded">gpp_maybe</div>

            <p>
              {this.state.selectedPersons.length >= 1
                ? I18n.t('toolbox.personSelected')
                : this.state[
                    `selected${
                      this.isJobsMode() ? 'Jobs' : 'Skills'
                    }`
                  ].length >= 1
                ? I18n.t('toolbox.skillsOrJobsSelected')
                : I18n.t('toolbox.notSelected')}
              <span className="bold">
                {this.state.selectedPersons.length >= 1
                  ? I18n.t(
                      `toolbox.personsSelected${this.state.selectedTab}NotSelected`,
                    )
                  : this.state[
                      `selected${
                        this.isJobsMode() ? 'Jobs' : 'Skills'
                      }`
                    ].length >= 1
                  ? I18n.t('toolbox.personsNotSelected')
                  : I18n.t(`toolbox.itemsNotSelected${this.state.selectedTab}`)}
              </span>
            </p>
          </div>
        )}
      </div>
    );
  };

  changeKeyToPagination = () => {
    if (!document.querySelector(`.active .results-${this.state.selectedTab}`)) {
      if (this._paginationKeyInterval) return;
      this._paginationKeyInterval = setInterval(() => {
        const results = document.querySelector(
          `.active .results-${this.state.selectedTab}`,
        );
        if (results) {
          this.setState({ ...this.state, changeTab: !this.state.changeTab });
          clearInterval(this._paginationKeyInterval);
          this._paginationKeyInterval = null;
        }
      }, 500);
    }
  };

  renderHeader = (key) => {
    const results = document.querySelector(
      `.active .results-${this.state.selectedTab}`,
    );
    let resultViewWidth;
    let resultRealWidth;
    let resultItemWidth;
    let activeNavigationClass = false;

    if (results) {
      resultViewWidth = results.offsetWidth;
      resultRealWidth = results.scrollWidth;
      if (resultViewWidth < resultRealWidth) activeNavigationClass = true;
      resultItemWidth = document.querySelector(
        '.active .results .result-column',
      )?.offsetWidth;
    }
    const margin = resultItemWidth === 200 ? 20 : 30;

    return (
      <div className="header-right" key={key}>
        {this.state.selectedTab !== TAB_DISC && (
          <div>
            <Button
              onClick={() => this.modalShow()}
              disabled={this.state.selectedPersons.length > 0 ? false : true}
              className={'secondary text-white p-0'}
              iconButton={true}
              iconClass={'download'}
              text={I18n.t('buttons.download')}
            />
          </div>
        )}
        <div
          className={`navigation-container ${
            activeNavigationClass ? 'active' : 'disable'
          }`}
        >
          <div
            onClick={() => {
              results.scrollLeft = 0;
            }}
            class="material-symbols-rounded"
          >
            first_page
          </div>
          <div
            class="material-symbols-rounded"
            onClick={() => {
              results.scrollLeft =
                results.scrollLeft - (resultItemWidth + margin);
            }}
          >
            navigate_before
          </div>
          <div
            class="material-symbols-rounded"
            onClick={() => {
              results.scrollLeft =
                results.scrollLeft + resultItemWidth + margin;
            }}
          >
            navigate_next
          </div>
          <div
            onClick={() => (results.scrollLeft = resultRealWidth)}
            class="material-symbols-rounded"
          >
            last_page
          </div>
        </div>
      </div>
    );
  };

  renderPositions = () => {
    return (
      <ToolboxColumn
        className="positions"
        infiniteScroll={false}
        title={I18n.t('toolbox.jobs')}
        headerIcon={
          <Tooltip
            message={this.tooltipMessage(this.state.selectedTab)}
            translate={false}
            materialIcon="contact_support"
            className={`tooltip-on-${this.state.selectedTab}`}
          />
        }
        items={this.props.jobs.map((job) => ({
          id: job.id,
          title: job.name,
          subtitle: job?.profile[`name_${this.props.language}`],
        }))}
        selected={this.state.selectedJobs}
        handleSelect={this.handleSelect}
        name={'selectedJobs'}
        totalCount={this.props.jobs?.length || 0}
        updateToolboxFilter={this.props.updateToolboxFilter}
        toolboxFilter={this.props.toolboxFilterJobs}
        profiles={this.props.allProfiles.map((profile) => {
          if (profile.id !== 27) {
            return {
              subtitle: {
                code: profile.id,
                description: profile.name,
              },
            };
          }
        })}
        dropDownClean={this.dropDownClean}
      />
    );
  };

  /**
   * Renders GeneratePdfHtml with correct props.
   * Renders an overlay in front of GeneratePdfHtml.
   *
   *  - render table.
   *  - click 'generate pdf'.
   *  - loader in front of table.
   *  - pdf file downloads.
   *  - table appears again.
   */
  renderGeneratePdf() {
    let columns = this.state.values[this.state.screen].inputValue;
    const tableData =
      columns.length > 0
        ? this.state.screen === 'capabilities'
          ? this.props.profileSkillsRanges
          : this.props.jobCompatibility
        : [];
    return (
      <div className="generatePdf-container">
        <div className="generatePdf-overlay">
          <Loader />
        </div>
        <GeneratePdfHtml
          id="generatePdf-elementToPrint"
          data={tableData}
          columns={columns}
          screen={this.state.screen} // capabilities or jobs
          profileSkillsRangesStatus={this.props.profileSkillsRangesStatus}
          defaultSorted={this.state.sorted}
        />
      </div>
    );
  }
}

GroupTrends.defaultProps = {};

export default GroupTrends;
